<script>
import * as m from '@app/paraglide/messages.js';
import {
    historyState,
    undoHistory
} from '@app/store/historyStore.svelte.js';
import {
    isSelectedEventGroupLocked
} from '@app/store/eventGroupStore.svelte.js';
import { toast } from '@zerodevx/svelte-toast';

let isLocked = $derived(isSelectedEventGroupLocked());
let isDisabled = $derived(historyState.position <= 1 || isLocked);

function guardedUndo() {
    if (isSelectedEventGroupLocked()) {
        toast.push(m.event_group_locked_toast(), { classes: ["toast-warning"] });
        return;
    }
    undoHistory();
}
</script>

<li class="nav-item" title={m.toolbar_secondary_undo_title()}>
    <a
        class="nav-link"
        href="#!/"
        role="button"
        aria-label={m.toolbar_secondary_undo_aria_label()}
        class:disabled={isDisabled}
        aria-disabled={isDisabled}
        onclick={guardedUndo}
    ><i class="bi bi-arrow-counterclockwise"></i></a>
</li>
